import { atom } from 'jotai';

import type { Report } from 'src/types/report';

export const reportCache = atom<{ [orgUnitId: number]: Report[] }>({});
